<template>
  <div id="map_container" class="map_container">
    <div class="layer-control">
      <el-checkbox v-for="item in markerOptions"
                   :key="item.value"
                   class="checkbox"
                   v-model="item.checked"
                   @change="changeLayer(item)">{{ item.label }}
      </el-checkbox>
    </div>
  </div>
</template>

<script>
import {clearMarkers, initMap} from "@/utils/mapUtil/funcs";
import {mapGetters} from "vuex";
import L from 'leaflet'
import 'leaflet.heat'
import {DASHBOARD_MARKER_TYPES, MARKER_TYPES} from "@/utils/mapUtil/constants";
import {loadMarkersBatch} from "@/utils/mapUtil/layerControl";
import {getHeatMapData} from "@/api/screenStatistics";
import {message as Message} from "@/js/utils/message";
import {addMapMarkers, handleZoomForBoundary} from "@/utils/mapUtil/leafletFun";
import {layerServiceURL} from "@/utils/mapUtil/layerServiceURL";

export default {
  name: "LeafletMap",
  computed: {
    ...mapGetters(["topSelectAreacode", 'topSelectAreaname', 'identityObj']),
  },
  data() {
    return {
      map: null,
      areaCode: '',
      markerOptions: [
        {value: 'star', label: '星级园区', checked: false},
        {value: 'heat', label: '流转热力图', checked: true},
        {value: 'business', label: '新型经营主体', checked: true},
        {value: 'company', label: '农事服务商', checked: true},
        {value: 'agricultural', label: '农资经销商', checked: true},
        {value: 'machinery', label: '在线农机', checked: true}
      ],
      heatmapData: [], // 用于存储热力图的数据
      filteredData: {}, // 用于存储过滤后的数据
    }
  },
  methods: {
    // 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
    handleZoomEnd() {

      const zoomRanges = [
        { layerType: 'service', range: [12, 20], ...layerServiceURL['china_township'] },
      ];
      handleZoomForBoundary(this.map, this, zoomRanges)
    },

    // 加载所有地图
    initAllMap() {
      // 行政区边界
      addMapMarkers(this.map, this.identityObj.areaFullName, this.identityObj.areaName, this.identityObj.centerPoint)
      // 热力图
      this.addHeatMap()
      // 在线农机
      this.addOnlineMachineryMarkers()
      // 农资商
      this.addAgriculturalMarkers()
      // 农机服务商
      // this.addMachineryMarkers()
      // 农事服务商
      this.addCompanyMarkers()
      // 经营主体
      this.addBusinessMarkers()
    },

    // 在线农机图层 增加弹窗5
    addOnlineMachineryMarkers() {
      loadMarkersBatch(DASHBOARD_MARKER_TYPES.machineryCar, {areaCode: this.areaCode}, this.map.onlineMachineryLayer)
    },
    // 农资商数据 4 弹窗符合
    addAgriculturalMarkers() {
      loadMarkersBatch(MARKER_TYPES.agricultural, {areaCode: this.areaCode}, this.map.agriculturalLayer)
    },

    // 经营主体 增加弹窗6
    addBusinessMarkers() {
      loadMarkersBatch(DASHBOARD_MARKER_TYPES.business, {areaCode: this.areaCode}, this.map.businessLayer)
    },

    // 农事服务商 托管服务商 1 弹窗不符合
    addCompanyMarkers() {
      loadMarkersBatch(DASHBOARD_MARKER_TYPES.companyService, {areaCode: this.areaCode}, this.map.companyServiceLayer)
    },

    // 农机服务商 2 弹窗不符合
    addMachineryMarkers() {
      loadMarkersBatch(DASHBOARD_MARKER_TYPES.machineryService, {areaCode: this.areaCode}, this.map.machineryServiceLayer)
    },

    // 星级园区
    addStarMarkers() {
    },

    // 热力图
    async addHeatMap() {
      const res = await getHeatMapData({
        areaCode: this.areaCode,
      });
      if (res.code === 0) {
        this.heatmapData = res.data.map(item => {
          return [item.lat, item.lng, item.areaNum]
        });
        // 生成热力图图层，并添加到地图中
        let heat = L.heatLayer(this.heatmapData, {
          radius: 12, minOpacity: 0.8, max: 100, blur: 20,
          gradient: {      // 颜色渐变配置
            0.0: 'rgba(50, 50, 256, 0.6)',
            0.2: 'rgba(50, 250, 56, 0.4)',
            0.4: 'rgba(50, 250, 56, 0.5)',
            0.6: 'rgba(50, 250, 56, 0.65)',
            0.8: 'rgba(250, 50, 56, 0.5)',
            1.0: 'rgba(250, 50, 56, 0.65)'
          }
        }).addTo(this.map.heatLayer);
        console.log(this.heatmapData, 'this.heatmapData');
      }
    },

    // 切换图层
    changeLayer(item) {
      // 根据 item.value 和 item.checked 控制对应图层的显示或隐藏
      switch (item.value) {
        case 'star':
          // 处理星级园区图层的显示/隐藏逻辑
          Message({
            message: "暂无星级园区数据！",
            type: "success",
          });
          // if (item.checked) {
          //   this.addStarMarkers();
          // } else {
          //   clearMarkers(this.map.starLayer); // 清除该图层
          // }
          break;
        case 'heat':
          // 处理流转热力图图层的显示/隐藏逻辑
          if (item.checked) {
            this.addHeatMap();
          } else {
            clearMarkers(this.map.heatLayer); // 清除该图层
          }
          break;
        case 'business':
          // 新型经营主体图层的显示/隐藏逻辑
          if (item.checked) {
            this.addBusinessMarkers();
          } else {
            clearMarkers(this.map.businessLayer);
          }
          break;
        case 'company':
          // 农事服务商图层的显示/隐藏逻辑
          if (item.checked) {
            this.addCompanyMarkers();
          } else {
            clearMarkers(this.map.companyServiceLayer);
          }
          break;
        case 'agricultural':
          // 农资经销商图层的显示/隐藏逻辑
          if (item.checked) {
            this.addAgriculturalMarkers();
          } else {
            clearMarkers(this.map.agriculturalLayer);
          }
          break;
        case 'machinery':
          // 在线农机图层的显示/隐藏逻辑
          if (item.checked) {
            this.addOnlineMachineryMarkers();
          } else {
            clearMarkers(this.map.onlineMachineryLayer);
          }
          break;
        default:
          break;
      }
    }

    // 土地流转热力图
  },
  mounted() {
    this.areaCode = this.identityObj.areaCode;
    this.map = initMap("map_container")
    //创建图层,用于存放各种要素
    this.map.onlineMachineryLayer = L.featureGroup().addTo(this.map);
    this.map.agriculturalLayer = L.featureGroup().addTo(this.map);
    this.map.businessLayer = L.featureGroup().addTo(this.map);
    this.map.companyServiceLayer = L.featureGroup().addTo(this.map);
    this.map.machineryServiceLayer = L.featureGroup().addTo(this.map);
    this.map.starLayer = L.featureGroup().addTo(this.map);
    this.map.heatLayer = L.featureGroup().addTo(this.map);
    // 添加初始地图
    this.initAllMap()
    // 监听地图缩放事件 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
    this.map.on('zoomend', this.handleZoomEnd);
  },
}
</script>

<style lang="less" scoped>
.map_container {
  width: 100%;
  height: 85%;
  background: rgba(6, 30, 93, 0.5);
  border-radius: 10px;
  position: relative;

  .layer-control {
    position: absolute;
    //width: 150px;
    //height: 200px;
    background-color: rgba(73, 79, 79, 0.5);
    border-radius: 5px;
    z-index: 1000;
    bottom: 30px;
    left: 30px;
    display: flex;
    flex-direction: column;

    ::v-deep .checkbox {
      color: #0000c5;
      font-size: 15px;
      margin: 5px 10px;
    }

    ::v-deep .el-checkbox__label {
      color: #0000c5;
    }

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #0000c5;
      border-color: #0000c5;
    }
  }
}
</style>
